import gql from 'graphql-tag'

export const closeLostLead = gql`
  mutation closeLostLead($idLead:Int!,$idClosingReason: Int!){
    close_lost_lead(idLead: $idLead, idClosingReason: $idClosingReason){
      id
    }
  }
`
